import { CountyProps } from '@/models/County';
import { ProgramNames } from '@/models/Program';
import { StateProps } from '@/models/State';
import { UserType } from '@/models/User';

import { CountySelect } from './ReviewerAssignmentSelects/CountySelect';
import { ProgramSelect } from './ReviewerAssignmentSelects/ProgramSelect';
import { StateSelect } from './ReviewerAssignmentSelects/StateSelect';

export function DomesticAssignmentFields({
  type,
  states,
  selectedPrograms,
  onProgramsChange,
  selectedState,
  onStateChange,
  selectedCounties,
  onCountiesChange,
  countiesInState,
}: {
  type: UserType;
  states: StateProps[];
  selectedPrograms: ProgramNames[];
  onProgramsChange: (programIds: ProgramNames[]) => void;
  selectedState: string | null;
  onStateChange: (stateId: string | null) => void;
  selectedCounties: string[];
  onCountiesChange: (countyIds: string[]) => void;
  countiesInState: CountyProps[];
}) {
  return (
    <>
      <StateSelect selectedState={selectedState} onStateChange={onStateChange} states={states} />

      {type === UserType.RegionalCoordinator && (
        <CountySelect
          selectedCounties={selectedCounties}
          onCountiesChange={onCountiesChange}
          countiesInState={countiesInState}
        />
      )}

      <ProgramSelect selectedPrograms={selectedPrograms} onProgramsChange={onProgramsChange} />
    </>
  );
}
